import { Typography } from '@breetometer/components';
import { CopyIcon } from 'BreetAssets';
import { Amount, RowSection } from 'BreetComponents';
import { copyToClipboard, formatDateTime } from 'BreetHelpers';
import { useCurrencyOutput } from 'BreetHooks';
import { selectFiatMeta, useAppSelector } from 'BreetRedux';

import type { ITopupProps } from '../DialogWithdrawalHistoryDetails.helpers';
import RowBalance from './RowBalance';
import RowStatusNote from './RowStatusNote';

const Topups = ({ withdrawalHistoryData }: ITopupProps) => {
	const fiatMetaProps = useAppSelector(selectFiatMeta);

	const currencyOutput = useCurrencyOutput();

	return (
		<>
			<div className='transactiondetails_header'>
				<Typography as='p'>TOPUP</Typography>
				<Typography as='h5'>
					{fiatMetaProps.currencySymbol}
					<Amount>{currencyOutput(withdrawalHistoryData.amount)}</Amount>
				</Typography>
			</div>

			<div className='transactiondetails_itemscontainer bg-primary-500'>
				<RowSection.Single
					label='Account Number'
					component={
						<div className='transactiondetails_value'>
							<Typography className='color-neutral-50'>{withdrawalHistoryData.doc.accountNumber}</Typography>
							<CopyIcon
								variant='colored'
								focusable
								aria-label='Copy account number'
								role='button'
								tabIndex={0}
								onClick={copyToClipboard(withdrawalHistoryData.doc.accountNumber, 'Account Number copied successfully')}
								className='cursor_pointer hide-during-screenshot'
							/>
						</div>
					}
				/>

				<RowSection.Single
					label='Account Name'
					component={
						<div className='transactiondetails_value'>
							<Typography className='color-neutral-50'>{withdrawalHistoryData.doc.accountName}</Typography>
						</div>
					}
				/>

				<RowSection.Single
					label='Bank'
					component={
						<div className='transactiondetails_value'>
							<Typography className='color-neutral-50'>{withdrawalHistoryData.doc.bankName}</Typography>
						</div>
					}
				/>

				<RowSection.Single
					label={"Sender's Name"}
					component={
						<div className='transactiondetails_value'>
							<Typography className='color-neutral-50'>{withdrawalHistoryData.doc.senderName}</Typography>
						</div>
					}
				/>

				<RowSection.Single
					label='Reference ID'
					component={
						<div className='transactiondetails_value'>
							<Typography className='color-neutral-50'>{withdrawalHistoryData.doc._id}</Typography>
							<CopyIcon
								variant='colored'
								focusable
								aria-label='Copy reference ID'
								role='button'
								tabIndex={0}
								onClick={copyToClipboard(withdrawalHistoryData.doc._id, 'Reference ID copied successfully')}
								className='cursor_pointer hide-during-screenshot'
							/>
						</div>
					}
				/>

				<RowSection.Single
					label='Fee'
					component={
						<div className='transactiondetails_value'>
							<Typography className='color-neutral-50'>
								{fiatMetaProps.currencySymbol}
								<Amount>{currencyOutput(withdrawalHistoryData.doc.fee)}</Amount>
							</Typography>
						</div>
					}
				/>

				<RowStatusNote
					status={withdrawalHistoryData.status}
					note={withdrawalHistoryData.doc.reason}
					noteStatus={withdrawalHistoryData.status === 'failed' ? 'error' : 'success'}
				/>

				{withdrawalHistoryData.status === 'completed' && (
					<RowBalance
						symbol={fiatMetaProps.currencySymbol}
						before={currencyOutput(withdrawalHistoryData.doc.balanceBefore)}
						after={currencyOutput(withdrawalHistoryData.doc.balanceAfter)}
					/>
				)}

				<RowSection.Single
					label='Date'
					component={
						<div className='transactiondetails_value'>
							<Typography className='color-neutral-50'>{formatDateTime(withdrawalHistoryData.updatedAt)}</Typography>
						</div>
					}
				/>
			</div>
		</>
	);
};

export default Topups;
